import { useState } from 'react';
import { defaultLang, supportedLangs } from './i18n';

export function normalizeLanguage(value) {
  if (typeof value !== 'string') return null;
  const base = value.toLowerCase().replace(/_/g, '-').split('-')[0];
  return supportedLangs.includes(base) ? base : null;
}

export function detectInitialLanguage() {
  if (typeof window === 'undefined') return defaultLang;
  try {
    const stored = normalizeLanguage(window.localStorage.getItem('preferredLang'));
    if (stored) return stored;
  } catch {
    // Storage can be unavailable in private mode; still check browser languages.
  }
  const candidates = [...(window.navigator.languages || []), window.navigator.language];
  for (const candidate of candidates) {
    const language = normalizeLanguage(candidate);
    if (language) return language;
  }
  return defaultLang;
}

export function useLanguage() {
  const [language, setLanguage] = useState(detectInitialLanguage);
  const changeLanguage = (value) => {
    const next = normalizeLanguage(value);
    if (!next) return;
    setLanguage(next);
    try {
      window.localStorage.setItem('preferredLang', next);
    } catch {
      // The selected language still applies when persistence is unavailable.
    }
  };
  return [language, changeLanguage];
}
